import { PerguntaResposta, QuestoesRespondidasMap, SectionPergunta } from './indicacao-clinica/model-indicacaoClinica'

export const getPerguntasRespondidas = (
  perguntas: SectionPergunta[],
  questoesRespondidas: QuestoesRespondidasMap
): PerguntaResposta[] =>
  perguntas
    .filter(({ name }) => questoesRespondidas.has(name))
    .map(({ name, label, size }) => ({ name, label, resposta: questoesRespondidas.get(name)!, size: size ?? 6 }))
